<div class="vs-homepage-overlay" #videoTutorOverlay>
    <span class="overlay-txt">
        <em class="material-icons custom-close" (click)="closeSiteVideoOverlay();">close</em>
    </span>
</div>

<div class="video-container" #containerDesc *ngIf="isValidURL">
    <iframe
    [src]="safeURL"
    title="Video Tutorial" 
    width="615" height="415"
    frameborder="0" 
    allow="autoplay; encrypted-media"></iframe>
</div>